import { useState } from 'react';
import {
  TooltipContainer,
  TooltipTrigger,
  TooltipIcon,
  TooltipContent,
  TooltipHeader,
  TooltipTitle,
  TooltipCloseButton,
  TooltipCloseIcon,
  TooltipBody,
} from './Tooltip.style';

interface TooltipProps {
  title: string;
  content: string;
}

export default function Tooltip({ title, content }: TooltipProps) {
  const [isOpen, setIsOpen] = useState(false);
  const tooltipId = `tooltip-${title.toLowerCase().replace(/\s+/g, '-')}`;

  return (
    <TooltipContainer>
      <TooltipTrigger
        onClick={() => setIsOpen((prev) => !prev)}
        onMouseEnter={() => setIsOpen(true)}
        onMouseLeave={() => setIsOpen(false)}
        onFocus={() => setIsOpen(true)}
        onBlur={() => setIsOpen(false)}
        type="button"
        aria-label="Mostrar informações"
        aria-expanded={isOpen}
        aria-controls={tooltipId}
      >
        <TooltipIcon />
      </TooltipTrigger>
      {isOpen && (
        <TooltipContent id={tooltipId} role="tooltip">
          <TooltipHeader>
            <TooltipTitle>{title}</TooltipTitle>
            <TooltipCloseButton onClick={() => setIsOpen(false)} type="button" aria-label="Fechar tooltip">
              <TooltipCloseIcon />
            </TooltipCloseButton>
          </TooltipHeader>
          <TooltipBody>{content}</TooltipBody>
        </TooltipContent>
      )}
    </TooltipContainer>
  );
}
